import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { EpicSpinIDControl } from "../epic-spin-id-control";

export class EpicSpinIDControlFactory implements ControlFactory {
    public filter(layer: Layers) {
        if (layer.getFlexiText("spin_id")) {
            return true;
        }

        return false;
    }

    public build(layer: Layers) {
        return [new EpicSpinIDControl(layer.getFlexiText("spin_id"))];
    }
}
